import React from 'react';

// ** Styles
import { AboutStyled, DescriptionWrapper } from './about.styled';

// ** Components
import { LogoBackground, Typography } from 'components';

// ** Hooks
import { usePartnersData } from 'data/hooks/partners/use-partners-data';

export const About = () => {
  const { aboutSection } = usePartnersData();
  return (
    <AboutStyled>
      <LogoBackground />

      <DescriptionWrapper>
        <Typography variant="p" typographyType="bodyRegular">
          {aboutSection.description}
        </Typography>
      </DescriptionWrapper>
    </AboutStyled>
  );
};
